import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
    path: "/",

    component: function() {
        return import ( /* webpackChunkName: "front" */ "../views/front/index.vue");
    },
    children: [{
            path: "/",
            name: "home",

            component: function() {
                return import (
                    /* webpackChunkName: "front" */
                    "../views/front/home.vue"
                );
            }
        },
        {
            path: "/about-us",
            name: "aboutUs",

            component: function() {
                return import (
                    /* webpackChunkName: "front" */
                    "../views/front/aboutUs.vue"
                );
            }
        },
        {
            path: "/contact-managment",
            name: "aboutUs",

            component: function() {
                return import (
                    /* webpackChunkName: "front" */
                    "../views/front/contactManagement.vue"
                );
            }
        },
      

        

        {
            path: "/weblogs",
            name: "weblogs",

            component: function() {
                return import (
                    /* webpackChunkName: "front" */
                    "../views/front/blogs.vue"
                );
            }
        },


        {
            path: "/video",
            name: "video",

            component: function() {
                return import (
                    /* webpackChunkName: "front" */
                    "../views/front/video.vue"
                );
            }
        },

        {
            path: "/image/:id",
            name: "image",

            component: function() {
                return import (
                    /* webpackChunkName: "front" */
                    "../views/front/image.vue"
                );
            }
        },

       
        {
            path: "/products",
            name: "products",

            component: function() {
                return import (
                    /* webpackChunkName: "front" */
                    "../views/front/products.vue"
                );
            }
        },

        {
            path: "/product-detail/:id/:slug?",
            name: "productDetail",

            component: function() {
                return import (
                    /* webpackChunkName: "front" */
                    "../views/front/product.vue"
                );
            }
        },


        

       
        {
            path: "/contact-us",
            name: "contactUs",
            // { path: '/', component: () => import('./Home.vue') }
            component: function() {
                return import (
                    /* webpackChunkName: "front" */
                    "../views/front/contactUs.vue"
                );
            }
        },
       
        {
            path: "/r-d",
            name: "rAndD",
            // { path: '/', component: () => import('./Home.vue') }
            component: function() {
                return import (
                    /* webpackChunkName: "front" */
                    "../views/front/RAD.vue"
                );
            }
        },
      

        

        {
            path: "/weblog-detail/:id/:slug?",
            name: "weblogs",

            component: function() {
                return import (
                    /* webpackChunkName: "front" */
                    "../views/front/blogDetail.vue"
                );
            }
        },

      
        {
            path: "/login",
            name: "loginRegister",

            component: function() {
                return import (
                    /* webpackChunkName: "front" */
                    "../views/front/loginRegister.vue"
                );
            }
        },
        {
            path: "/admin-panel",
            name: "adminPanel",

            component: function() {
                return import (
                    /* webpackChunkName: "admin" */
                    "../views/admin/index.vue"
                );
            },
            children: [

                {
                    path: "about-us",
                    name: "panelAboutUs",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/aboutUs.vue"
                        );
                    }
                },

                {
                    path: "contact-us",
                    name: "panelContactUs",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/contactUs.vue"
                        );
                    }
                },
               

                {
                    path: "contact-management-introduction",
                    name: "panelContactManagemnetIntroduction",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/contactUsManagement.vue"
                        );
                    }
                },
                {
                    path: "contact-us-introduction",
                    name: "panelContactUsIntroduction",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/contactUsIntroduction.vue"
                        );
                    }
                },




               
// partner panel





             

                {
                    path: "upload-file",
                    name: "uploadFile",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/uploadFile.vue"
                        );
                    }
                },
             
              



                {
                    path: "weblogs",
                    name: "panelWeblogs",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/weblogs.vue"
                        );
                    }
                },


                {
                    path: "weblogs-introduction",
                    name: "panelWeblogsIntroduction",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/weblogsIntroduction.vue"
                        );
                    }
                },


                {
                    path: "weblog-categories",
                    name: "panelWeblogCategories",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/weblogCategories.vue"
                        );
                    }
                },

                {
                    path: "weblog-comments",
                    name: "panelWeblogComment",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/weblogComments.vue"
                        );
                    }
                },


                {
                    path: "products",
                    name: "panelProducts",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/products.vue"
                        );
                    }
                },



                {
                    path: "products-introduction",
                    name: "panelProductsIntroduction",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/productsIntroduction.vue"
                        );
                    }
                },
                {
                    path: "product-comments",
                    name: "panelProductComment",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/productComment.vue"
                        );
                    }
                },

                {
                    path: "product-categories",
                    name: "panelProductCategories",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/productCategory.vue"
                        );
                    }
                },

               

                {
                    path: "product-feature",
                    name: "panelProductFeature",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/productFeature.vue"
                        );
                    }
                },
              

              

                

             
                // gallery
             
                {
                    path: "settings",
                    name: "panelSettings",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/settings.vue"
                        );
                    }
                },

                {
                    path: "users",
                    name: "panelUsers",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/users.vue"
                        );
                    }
                },
             

                {
                    path: "sliders",
                    name: "panelSliders",

                    component: function() {
                        return import (
                            /* webpackChunkName: "admin" */
                            "../views/admin/sliders.vue"
                        );
                    }
                },

            

               
             
              
               
            ]
        },
    ]
}];
// .vue
const router = new VueRouter({
    scrollBehavior(to, from, savedPosition) {

        if (to.name != from.name)
            window.scrollTo(0, 0)
            // ...
    },
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;